import { EditorColorFormat } from '../../../_models';
import { EditorColorService } from '../../../_services';

// Text / highlight color buttons that open the brand-swatch picker instead of TinyMCE's color grid.
// Usage: add 'swatch-colors' to plugins and 'swatch-forecolor' / 'swatch-backcolor' to the toolbar.
export class SwatchColorsPlugin {
  constructor(private tinymce: any, private editorColorService: EditorColorService) {}

  create() {
    this.tinymce.PluginManager.add('swatch-colors', (editor: any) => {
      this.addButton(editor, 'swatch-forecolor', 'text-color', 'Text color', EditorColorFormat.Text);
      this.addButton(editor, 'swatch-backcolor', 'highlight-bg-color', 'Background color', EditorColorFormat.Highlight);
      editor.on('mousedown', () => this.editorColorService.dismiss());
      editor.on('remove', () => this.editorColorService.release(editor));
    });
  }

  private addButton(editor: any, name: string, icon: string, tooltip: string, format: EditorColorFormat) {
    editor.ui.registry.addButton(name, {
      icon,
      tooltip,
      onAction: () => {
        const container = editor.getContainer();
        const anchor = container.querySelector('button[title="' + tooltip + '"]') || container;
        this.editorColorService.toggle(editor, name, anchor, {
          color: this.currentColor(editor, format),
          apply: (color: string) => editor.formatter.apply(format, { value: color }),
          remove: () => editor.execCommand('mceRemoveTextcolor', format),
        });
      },
    });
  }

  // Selection's current color; transparent / missing highlight starts empty.
  private currentColor(editor: any, format: EditorColorFormat): string {
    let color = editor.queryCommandValue(format === EditorColorFormat.Text ? 'ForeColor' : 'HiliteColor') || '';
    if (color === 'transparent' || /rgba\(.*,\s*0\)$/.test(color)) {
      color = '';
    }
    return color;
  }
}
